<script setup>
// Version and environment injected at build time via vite.config.js define.
const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.1';
const isProd = typeof __IS_PROD__ !== 'undefined' ? __IS_PROD__ : import.meta.env.PROD;
const year = new Date().getFullYear();
</script>

<template>
  <footer class="pos-footer">
    <span class="footer-copy">© {{ year }} Byte Gaming Arena</span>
    <span class="footer-sep" aria-hidden="true">/</span>
    <span class="footer-version">v{{ version }}</span>
    <span class="footer-sep" aria-hidden="true">/</span>
    <span :class="['footer-env', isProd ? 'footer-env--prod' : 'footer-env--dev']">
      {{ isProd ? 'PROD' : 'DEV' }}
    </span>
  </footer>
</template>

<style scoped>
.pos-footer {
  flex-shrink: 0;
  height: 22px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem;
  background: transparent;
  border-top: 1px solid oklch(100% 0.008 95 / 0.06);
}

.footer-copy,
.footer-version {
  font-family: var(--bc-font-mono);
  font-size: 10px;
  color: oklch(60% 0.008 95);
}

.footer-sep {
  font-family: var(--bc-font-mono);
  font-size: 10px;
  color: oklch(35% 0.008 95);
}

.footer-env {
  font-family: var(--bc-font-mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 1px 5px;
  border-radius: 3px;
}

.footer-env--prod {
  color: oklch(60% 0.008 95);
  background: oklch(100% 0.008 95 / 0.06);
}

.footer-env--dev {
  color: #000;
  background: var(--bc-neon-yellow);
}
</style>
